import { IOperationResultNoValue, UserSessionContext } from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IHangfireOperationsAuthTokenResult } from '../models';

export function useHangfireAuthTokenMutation({
	userSession,
	handleError,
}: {
	userSession: UserSessionContext;
	handleError?: (err: IOperationResultNoValue) => void;
}) {
	return useMutation({
		mutationFn: () => {
			return new Promise<IHangfireOperationsAuthTokenResult[]>((resolve, reject) => {
				return userSession.webServiceHelper.callWebServiceWithOperationResults<IHangfireOperationsAuthTokenResult[]>(
					'admin/HangfireOperations/dashboards',
					'GET',
					null,
					opResult => {
						resolve(opResult.value);
					},
					opResult => {
						reject(opResult);
					}
				);
			});
		},
		onError: handleError,
	});
}
